import { Text, HStack, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { productsCartState } from '../../../../../../store/batchTicket/atom';
import {
  customerCartCountSelector,
  customerCartEstimatedBalanceSelector,
  customerCartTotalAvailableBalanceSelector,
} from '../../../../../../store/batchTicket/selectors';
import { BatchTicketAssetsSelection } from '../../../../contexts';

interface BatchTicketCustomersSelectedProps {}

export const hasAnyItems = (data: BatchTicketAssetsSelection) => {
  return Object.values(data).some((option) => option.items.length > 0);
};

export const BatchTicketCustomersSelected: React.FC<BatchTicketCustomersSelectedProps> = () => {
  const customerCartCount = useRecoilValue(customerCartCountSelector);
  const customerCartTotalAvailableBalance = useRecoilValue(
    customerCartTotalAvailableBalanceSelector
  );
  const productsCartList = useRecoilValue(productsCartState);
  const customerCartEstimatedBalance = useRecoilValue(customerCartEstimatedBalanceSelector);
  const showEstimatedValue = hasAnyItems(productsCartList);

  return (
    <HStack
      alignItems="center"
      justifyContent="space-between"
      px={Spacing['inline.xxs']}
      pb={Spacing['inline.xxs']}>
      <VStack>
        <Text variant="semibold" color="neutral.darkest">
          Cliente(s) adicionado(s)
        </Text>
        <Text color="neutral.darkest">{customerCartCount} clientes</Text>
      </VStack>
      <HStack alignItems="center" space={Spacing['inline.xs']}>
        <VStack>
          <Text variant="semibold" color="neutral.darkest">
            Saldo disponível
          </Text>
          <Text
            color={
              customerCartTotalAvailableBalance.total < 0
                ? 'feedback.error.default'
                : 'neutral.darkest'
            }>
            {customerCartTotalAvailableBalance.totalFormatted}
          </Text>
        </VStack>
        <VStack alignItems="flex-end">
          <Text variant="semibold" color="neutral.darkest">
            Saldo estimado
          </Text>
          <Text color="neutral.darkest">
            {showEstimatedValue
              ? customerCartEstimatedBalance.totalFormatted
              : 'Adicione os produtos'}
          </Text>
          <Text fontSize={Typography['fontsize.xs']} color="neutral.medium">
            Após o investimento
          </Text>
        </VStack>
      </HStack>
    </HStack>
  );
};
